import { render } from "./CTASection.vue?vue&type=template&id=09372841&scoped=true"
const script = {}

import "./CTASection.vue?vue&type=style&index=0&id=09372841&scoped=true&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09372841"]])

export default __exports__